var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useNotification } from "@/components/Notify";
import { Loading } from "@/layouts/components";
import { RoutesList } from "@/router/routesList";
import { useGetGameByIdQuery, useUpdateGameMutation } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { convertToGameUpdateDto } from "../common/mappers/convertFromViewModel";
import { convertGameToViewModel } from "../common/mappers/convertToViewModel";
import { GameStep1 } from "./components/GameStep1";
import { GameStep2 } from "./components/GameStep2";
export var GameEditPage = function () {
    var navigate = useNavigate();
    var gameId = useParams().gameId;
    var gameGetState = useGetGameByIdQuery({ id: gameId });
    var _a = useUpdateGameMutation(), gameUpdateAction = _a[0], gameUpdateState = _a[1];
    var _b = useNotification(), showSuccess = _b.showSuccess, showError = _b.showError;
    var _c = useState(1), currentStep = _c[0], setCurrentStep = _c[1];
    var _d = useState(null), step1Data = _d[0], setStep1Data = _d[1];
    var saveFormHandler = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, gameUpdateAction({
                            id: data.id,
                            updateGameDto: convertToGameUpdateDto(data),
                        }).unwrap()];
                case 1:
                    _a.sent();
                    showSuccess({ message: "Игра сохранена" });
                    navigate(RoutesList.Game.getGamesList());
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    showError({ message: "Ошибка сохранения игры" });
                    console.error(err_1);
                    throw err_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleStep1Next = function (data) {
        setStep1Data(data);
        setCurrentStep(2);
    };
    var handleStep2Back = function () {
        setCurrentStep(1);
    };
    var handleStep2Save = function (fullData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveFormHandler(fullData)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useSetPageData({ title: "Игра" });
    var isLoading = gameGetState.isLoading || gameUpdateState.isLoading;
    var gameViewModel = useMemo(function () {
        if (!gameGetState.isSuccess) {
            return null;
        }
        return convertGameToViewModel(gameGetState.data);
    }, [gameGetState.data, gameGetState.isSuccess]);
    var step2ViewModel = useMemo(function () {
        if (!gameViewModel || !step1Data) {
            return null;
        }
        return __assign(__assign({}, gameViewModel), { placeId: step1Data.placeId, date: step1Data.date, timeStart: step1Data.timeStart, timeEnd: step1Data.timeEnd });
    }, [gameViewModel, step1Data]);
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: isLoading, loadingKey: "gameEditForm" }), step2ViewModel && currentStep === 2 && (_jsx(GameStep2, { data: step2ViewModel, step1Data: step1Data, onBack: handleStep2Back, onSave: handleStep2Save })), gameViewModel && currentStep === 1 && (_jsx(GameStep1, { data: gameViewModel, onNext: handleStep1Next }))] }));
};
